export const API_URL = process.env.REACT_APP_API_URL || "https://api.sparkademy.com/v1";
export const HASURA_API_URL =
  process.env.REACT_APP_HASURA_API_URL || "https://hasura.sparkademy.com/v1";
